export const getLocationName = (id, serviceProviderLocations) => {
  let location = serviceProviderLocations.find((item) => item.id === id);
  if (location) {
    return location.service_location_name;
  }
  return '';
};

export const getCurrentStage = (stages, stageId) => {
  return stages.find((item) => String(item.id) === String(stageId));
};
